import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.LandingPagePane.title',
    defaultMessage: 'Landing Page',
  },
})
